<template>
  <div>
    <v-dialog
      v-model="serverErrorDialog.show"
      :persistent="true"
      max-width="600"
    >
      <v-card>
        <v-card-text>
          <p class="title">
            <h3><v-icon medium color="red">mdi-alert</v-icon>&nbsp;Galaxy Tool Error</h3>
          </p>
          <p class="description">
            Please log a trouble ticket to the support team by email to  GuardiansoftheGalaxy@dxc.com<br />
            <ul class="mt-2">
              <li>Provide screenshot with summary of the issue.</li>
              <li>You will receive acknowledgement of the issue within 1 business day maximum.</li>
              <li>If you need personal screen share assistance, please include that request in your error report.</li>
              <li>Target resolution within 2 business days.</li>
            </ul>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="orange"
            @click="serverErrorDialog.show = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import { mapState } from 'vuex'
export default {
  computed: mapState(['serverErrorDialog'])
}
</script>
<style scoped>

p.description {
  color: #000;
}
  
</style>
